import { createSlice } from '@reduxjs/toolkit'

export const stepOneSlicer = createSlice({
  name: 'stepOne',
  initialState: {
    arr: {}
  },
  reducers: {

    add: (state, action) => {
          state.arr = action.payload; 
    },
  },
})

// Action creators are generated for each case reducer function
export const { add } = stepOneSlicer.actions

export default stepOneSlicer.reducer